import type { PaginationConfig } from './ImageGallery.common';

export const getShimmerCount = (
  pagination: PaginationConfig | undefined,
  loadedCount: number
): number => {
  if (!pagination?.pageSize) return 0;
  const remaining = pagination.totalImageCount - loadedCount;
  return Math.min(pagination.pageSize, Math.max(remaining, 0));
};

export const shouldLoadMore = (pagination: PaginationConfig | undefined): boolean =>
  Boolean(pagination?.hasMore && !pagination?.isLoadingMore);
